import { render, staticRenderFns } from "./DashboardConfigModal.vue?vue&type=template&id=202ab77c&scoped=true"
import script from "./DashboardConfigModal.vue?vue&type=script&lang=js"
export * from "./DashboardConfigModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardConfigModal.vue?vue&type=style&index=0&id=202ab77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ab77c",
  null
  
)

export default component.exports